import { type CompanyRequest, type CompanyResponse } from "../api";
import { Utility } from "./utility";

export interface Company extends CompanyResponse {
  get_local_time(time_string: string): Date;
}

export class Company extends Utility<Company> {
  constructor(init?: Partial<CompanyResponse>) {
    super();
    Object.assign(this, init);
  }

  get completed(): boolean {
    // return ((this.name && this.description && this.culture) || "").length > 0;
    return ((this.name && this.description) || "").length > 0;
  }

  toRequest(): CompanyRequest {
    return {
      name: this.name ?? null,
      description: this.description ?? null,
      culture: this.culture ?? null,
    };
  }
}
